import * as React from "react";
import { styled } from "../../../../../../stitches.config";
import AnimateHeight, { Height } from "react-animate-height";

import ExpandBarBizon from "./ExpandBarBizon";

type Props = {
  children: React.ReactNode;
};

const AnimateFixedHeightWrapper: React.FC<Props> = ({ children }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [showButton, setShowButton] = React.useState(true);
  const currentHeight: Height = expanded ? "auto" : 200;

  React.useEffect(() => {
    if (expanded) {
      const timer = setTimeout(() => setShowButton(false), 500);
      return () => clearTimeout(timer);
    }
  }, [expanded]);

  return (
    <Wrapper>
      <AnimateHeight duration={500} height={currentHeight}>
        {children}
      </AnimateHeight>

      {showButton && <GradientOverlay />}

      {showButton && (
        <ArrowButton2 onClick={() => setExpanded(true)}>
          <ExpandBarBizon />
        </ArrowButton2>
      )}
    </Wrapper>
  );
};

export default AnimateFixedHeightWrapper;

const Wrapper = styled("div", {
  position: "relative",
  overflow: "hidden",
  paddingBottom: "32px",
});

const GradientOverlay = styled("div", {
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 48,
  height: 60,
  background: "linear-gradient(to bottom, rgba(255,255,255,0), #ffffff 100%)",
  pointerEvents: "none",
});

const ArrowButton2 = styled("div", {
  width: "100%",
  height: "26px",
  zIndex: 55,
  marginBottom: "-6px",
  cursor: "pointer",
  span: {
    fontWeight: "bold",
    fontSize: "1.5em",
  },
  button: {
    width: "100px",
    height: "25px",
    position: "absolute",
    color: "#ffffff",
    fontWeight: 700,
    background: "#ff6400",
    border: "none",
    fontSize: "0.8em",
    borderRadius: "5px",
    borderBottomRightRadius: "0",
    marginLeft: "-5px",
    textAlign: "left",
    lineHeight: "22px",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    display: "none",
  },
});
